const META_PIXEL_ID = '1576711500675070'

type MetaPixelFunction = {
  (command: string, ...args: unknown[]): void
  queue?: unknown[][]
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

export function initializeMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: MetaPixelFunction = (command, ...args) => {
    fbq.queue?.push([command, ...args])
  }

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  fbq('init', META_PIXEL_ID)
  fbq('track', 'PageView')
}

export function trackCheckoutStart() {
  window.fbq?.('track', 'InitiateCheckout')
}
